import * as React from "react";
import {render} from "react-dom";
import {Router, Route, browserHistory} from 'react-router';
import {scrollOnUpdate, historyState} from "./helpers";

// Components
import {Layout} from "./layout/Layout";
import {Main} from "./route/Main";
import {Sony} from "./route/Sony";
import {Members} from "./route/Members";
import {Visitors} from "./route/Visitors";
import {NewsRead} from "./route/NewsRead";
import {Paid} from "./route/Paid";
import {Accounting} from "./route/Dashboard/Accounting";
import {Dashboard} from "./route/Dashboard";
import {Restricted} from "./layout/Restricted";
import {Table} from "./route/Table";

browserHistory.listen(function ({action, pathname}) {
    if (action === 'PUSH') {
        historyState.pushes++;
    } else if (action === 'POP') {
        historyState.pops++;
    }
});

export const result = render(
    <Router history={browserHistory} onUpdate={scrollOnUpdate}>
        <Route component={Layout}>
            <Route path="/" component={Main} />
            <Route path="/members" component={Members} />
            <Route path="/sony" component={Sony} />
            <Route path="/visitors" component={Visitors} />
            <Route path="/news/:id" component={NewsRead} />
            <Route path="/paid/:id" component={Paid} />
        </Route>
        <Route component={Restricted}>
            <Route path="/dashboard" component={Dashboard} />
            <Route path="/dashboard/accounting" component={Accounting} />
        </Route>
        <Route path="/table/:table" component={Table} />
    </Router>
    ,
    document.getElementById("container")
);



/** WEBPACK FOOTER **
 ** ./src/index.tsx
 **/